import React from 'react';
import {useLoaderData, useMatches} from '@remix-run/react';

//components
import SanityRichText from 'components/modules/SanityRichText';
import SanityImage from 'components/SanityImage';

//data
import {loader} from '~/routes/($lang)/products/$productHandle';
import type {
  Metafield,
  Collection,
  ProductVariant,
} from '@shopify/hydrogen/storefront-api-types';
import {I18nLocale} from '~/lib/type';

interface BrandWithMetafeilds extends Pick<Collection, 'title' | 'id'> {
  is_brand?: Metafield;
  size_chart?: Metafield;
  shipping_status?: Metafield;
}

function shippingStatus({
  shippingStatus,
  quantityAvailable,
  language,
}: {
  shippingStatus: string;
  quantityAvailable: number;
  language: string;
}) {
  switch (shippingStatus) {
    case 'local-inventory':
      if (quantityAvailable <= 0) {
        return language === 'ZH_TW' ? '1-4 個星期' : '1-4 business weeks';
      }
      return language === 'ZH_TW' ? '1-3 個工作天' : '1-3 business Days';
    case 'hk-suppliers':
      if (quantityAvailable <= 0) {
        return language === 'ZH_TW' ? '1-4 個星期' : '1-4 business weeks';
      }
      return language === 'ZH_TW' ? '1-3 個工作天' : '1-3 business Days';
    case 'overseas-suppliers':
      if (quantityAvailable <= 0) {
        return language === 'ZH_TW' ? '1-4 個星期' : '1-4 business weeks';
      }
      return language === 'ZH_TW' ? '1-3 個工作天' : '1-3 business Days';
    case 'default':
    default:
      if (quantityAvailable <= 0) {
        return language === 'ZH_TW' ? '1-4 個星期' : '1-4 business weeks';
      }
      return language === 'ZH_TW' ? '1-3 個工作天' : '1-3 business Days';
  }
}

export default function ProductDetailsFooter({
  selectedVariant,
}: {
  selectedVariant: ProductVariant;
}) {
  const {productSettings, product} = useLoaderData<typeof loader>();
  const collections = product?.collections?.nodes as BrandWithMetafeilds[];
  const brand = collections?.find((c) => {
    return c?.is_brand?.value === 'true';
  });
  const [root] = useMatches();
  const selectedLocale = root?.data?.selectedLocale as I18nLocale;

  return (
    <>
      <div className="special-offer mb-[25px] text-[18px] font-normal">
        {productSettings?.product_settings_translations
          ?.shipping_messages_label ? (
          <SanityRichText
            richtext={
              productSettings?.product_settings_translations
                ?.shipping_messages_label
            }
          />
        ) : (
          <>
            ORDER <span className="font-normal text-hk-orange">HKS$500</span>{' '}
            FREE SHIPPING TO HONG KONG AND MACAU
          </>
        )}
      </div>
      <div className="special-offer mb-[25px] text-[18px] font-normal">
        {productSettings?.product_settings_translations
          ?.delivery_period_messages_label ?? 'Expected Delivery Period'}{' '}
        {' '}
        <span className="font-normal text-hk-orange">
          {shippingStatus({
            shippingStatus: brand?.shipping_status?.value ?? '',
            quantityAvailable: selectedVariant.quantityAvailable ?? 0,
            language: selectedLocale.language ?? 'ZH_TW',
          })}
        </span>
      </div>
      <div className="">
        <SanityImage
          layout="responsive"
          sizes={['50vw, 100vw']}
          src={
            productSettings?.product_settings_main?.payment_methods?.asset._ref
          }
          className="h-full object-cover"
        />
      </div>
    </>
  );
}
